import axios from "axios";
import { fpoLoginUrl } from "../constants/apis";

/**
 * FPO Login — sends multipart/form-data (username + password)
 */
export const loginApi = async ({ username, password }) => {
    const formData = new FormData();
    formData.append("username", username);
    formData.append("password", password);

    const response = await axios.post(fpoLoginUrl, formData);
    return response;
};
